"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRunnableProcess = void 0;
const wrapCallbackWithFunctionLogger_1 = __importDefault(require("../applicationFunctionality/wrapCallbackWithFunctionLogger"));
const valueIsNotUndefined_1 = __importDefault(require("../typeAssertions/valueIsNotUndefined"));
const createRunnableProcess = ({ functionId, functions, processor, extraFunctionDefinitions = {}, functionDefinitions, }) => {
    const apphiveFunction = functions[functionId];
    if (apphiveFunction === undefined) {
        return undefined;
    }
    let callable = functionDefinitions[apphiveFunction.function]
        || extraFunctionDefinitions[apphiveFunction.function];
    if (!callable) {
        if (Object.keys(extraFunctionDefinitions).length === 0) {
            return undefined;
        }
        callable = (() => undefined);
    }
    const { executionStatus } = apphiveFunction;
    const runnableProcess = {
        functionId,
        type: apphiveFunction.function,
        callbacksDefinition: apphiveFunction.callback,
        call: async (callparams) => {
            if (executionStatus === 'disabled') {
                return undefined;
            }
            const functionLogger = (executionStatus === 'debugging' && callparams.processor.root.isInDevelopment)
                ? await callparams.processor.root.createFunctionLogger(functionId)
                : undefined;
            const { entryVars } = callparams;
            const entryVarEntries = Object.entries(entryVars);
            const entryVarValues = {};
            for (let i = 0; i < entryVarEntries.length; i += 1) {
                const [entryVarKey, entryVarValue] = entryVarEntries[i];
                if (entryVarValue instanceof Promise) {
                    entryVarValues[entryVarKey] = await entryVarValue; // eslint-disable-line
                }
                else {
                    entryVarValues[entryVarKey] = entryVarValue;
                }
            }
            if (!callable) {
                return undefined;
            }
            let formatedCallbacks = callparams.callbacks;
            if (functionLogger) {
                await functionLogger.updateArgs(entryVarValues);
                if ((0, valueIsNotUndefined_1.default)(formatedCallbacks)) {
                    formatedCallbacks = (0, wrapCallbackWithFunctionLogger_1.default)({
                        parentFunctionId: functionId,
                        callbacks: formatedCallbacks,
                        functionLogger,
                    });
                }
            }
            const callResult = await callable(Object.assign(Object.assign({}, callparams), { callbacks: formatedCallbacks, entryVars: entryVarValues }));
            if (functionLogger) {
                await functionLogger.updateReturn(callResult);
            }
            return callResult;
        },
        moduleDefinition: apphiveFunction.moduleDefinition,
        entryVarsDefinition: apphiveFunction.entryVars,
        callbacks: Object.entries(apphiveFunction.callback || {})
            .reduce((newCallback, [callbackName, processes]) => {
            if (!processes) {
                return newCallback;
            }
            const process = processes
                .reduce((accum, processId) => {
                const resultProcess = (0, exports.createRunnableProcess)({
                    functionId: processId,
                    functions,
                    processor,
                    extraFunctionDefinitions,
                    functionDefinitions,
                });
                if (!resultProcess) {
                    return accum;
                }
                accum.push(resultProcess);
                return accum;
            }, []);
            if (process) {
                return Object.assign(Object.assign({}, newCallback), { [callbackName]: process });
            }
            return newCallback;
        }, {}),
        extraFunctionDefinitions,
    };
    return runnableProcess;
};
exports.createRunnableProcess = createRunnableProcess;
exports.default = exports.createRunnableProcess;
